import _isFunction from 'lodash.isfunction';

export function isFunction(value: any) {
  return _isFunction(value);
}
